/* 布局 */
//前台
import Layout from "@views/layout";

const sysemailarticleRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "sysemailarticle",
            name: "SYSEMAILARTICLE",
            meta: {
                title: "邮件发送管理",
                sort: 1,
            },
            component: () => import("@views/business/sysemailarticle/index.vue"),
            redirect: {
                name: "SYSEMAILARTICLE_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "SYSEMAILARTICLE_LIST",
                    meta: {
                        title: "邮件发送管理",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/sysemailarticle/list.vue"),
                },
                                {
                    path: "add",
                    name: "SYSEMAILARTICLE_ADD",
                    meta: {
                        title: "新增邮件发送管理",
                        parentPath: '/business/sysemailarticle/list',
                        operate: true,
                    },
                    component: () => import("@views/business/sysemailarticle/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "SYSEMAILARTICLE_EDIT",
                    meta: {
                        title: "编辑邮件发送管理",
                        parentPath: '/business/sysemailarticle/list',
                        operate: true,
                    },
                    component: () => import("@views/business/sysemailarticle/form.vue"),
                },
                                        ],
    },


        ],
};

export default sysemailarticleRouter;
